import { j as l, c } from "./utils-BdNIfrGQ.js";
import { l as x } from "./NavLink-D9Qfouy1.js";
import { n as f } from "./normalize-spacing-DY0KSpr_.js";
const g = ({
  href: a,
  children: n,
  variant: o,
  width: s,
  active: e,
  accent: t,
  spacing: i,
  target: m,
  rel: r,
  ...p
}) => /* @__PURE__ */ l.jsx(
  "a",
  {
    className: c(x({ variant: o, width: s, active: e, accent: t }), f(i)),
    ...p,
    rel: `noopener noreferrer${r ? ` ${r}` : ""}`,
    target: m || "_blank",
    href: a,
    children: n
  }
);
export {
  g as E
};
